function PriceModule(el) {
  var entries = el.querySelectorAll('.price-module__entry')
  if (entries.length === 0) return
  this.el = el;
  this.entries = entries;
  this.init();
}

PriceModule.prototype.init = function() {
  Array.prototype.forEach.call(this.entries, function(el) {
    var link = el.querySelector('.btn')
    if (!link) return
    var productName = el.querySelector('.price-module__product-name')
    if (!productName) return

    var params = new URLSearchParams(link.hash.startsWith('#') ? link.hash.slice(1) : link.hash)
    params.set("tarif", productName.textContent)

    link.hash = '#' + params.toString()

    link.addEventListener('click', callPreselectTarif)  // call on click and on hashchange to trigger scrollintoview even when the tarif didn't change
  })
}

Array.prototype.forEach.call(document.querySelectorAll('.price-module'), function(el) {
  new PriceModule(el);
});

function preselectTarif(el) {
  var params = new URLSearchParams(location.hash.startsWith('#') ? location.hash.slice(1) : location.hash)
  var tarif = params.get("tarif")

  if (tarif) {
    el.value = tarif

    el.closest('form').scrollIntoView();
  }
}

function callPreselectTarif() {
  Array.prototype.forEach.call(document.querySelectorAll('.nf_gewaehlter_tarif'), preselectTarif);
}

if (location.hash !== '') {
  jQuery(document).on('nfFormReady', callPreselectTarif)
  jQuery(window).on("load", function() {
    setTimeout(callPreselectTarif, 0)
  })
}
window.addEventListener("hashchange", callPreselectTarif, false); // runs after click event